/* global jQuery */
import React from 'react'
import classnames from 'classnames'
import { Video, Lazyload } from '../common'

export class VideoGrid extends React.Component {
  constructor() {
    super()
    this.state = {
      active : 'all'
    }
  }
  _switchTab(type) {
    this.setState({
      active : type
    })

    return false
  }

  componentDidUpdate() {
    const { gamepackageVideos = '' } = this.refs
    const highlights = jQuery(gamepackageVideos).find('.highlight')
    const highlightsSample = highlights.eq(0)
    const thumbWidth = highlightsSample.width()
    const thumbHeight = thumbWidth * 9 / 16

    highlights.css( 'min-height', thumbHeight )

    highlights.find('img').on('load error', function () {
      highlights.css( 'min-height', 0 )
    })
  }

  componentDidMount() {
    this.setState({ enableLazyload : true })
  }

  _renderTabs() {
    const { videos = [], tabs = {} } = this.props
    const { active } = this.state
    const tabsKey = Object.keys(tabs)
    let tabsToShow = []
    let displayTabs

    tabsToShow.push(tabs['all'])

    // map videos with pre-defined tabs
    videos.map((v) => {
      let coverageType = v.coverageType || ''
      coverageType = coverageType.toLowerCase()
      const tab = tabs[coverageType]

      /*
       * if 'coverageType' is available in 'tabsKey' and
       * if the tab is not available already in 'tabsToShow'
       */
      if (tabsKey.indexOf(coverageType) !== -1 && tabsToShow.indexOf(tab) === -1) {
        tabsToShow.push(tab)
      }
    })

    // show tabs only if the tabs count is more than one
    displayTabs = tabsToShow.length > 1 ? 'block' : 'none'

    return (
      <header className="video-toggle" style={{ 'display': displayTabs }}>
        <div className="button-group" data-behavior="tabs">
          {
            tabsToShow.map((t = {},i) => {
              return (
                <a
                  className={ classnames('button-filter-alt lg fixed',{ 'active' : (active === t.type) }) }
                  key={i}
                  router={false}
                  onClick={this._switchTab.bind(this, t.type)}>
                  { t.displayValue }
                </a>
              )
            })
          }
        </div>
      </header>
    )
  }

  render() {
    const {
      videos = [],
      page = 1,
      hasMore = true,
      updateMoreVideos
    } = this.props
    const { enableLazyload, active } = this.state
    const tabs = this._renderTabs()
    let enableForceLazyload = (active === 'all')

    return (
      <div id="gamepackage-videos" data-module="video" ref="gamepackageVideos">
        <div className="sub-module game-package-video" data-behavior="gamepackage_video">
          {tabs}
          { videos.length > 0 &&
            <div className="content">{
              videos.map((video = {}, i) => {
                let showVideo

                if (active === 'all' || active === (video.coverageType || '').toLowerCase()) {
                  showVideo = 'block'
                } else {
                  showVideo = 'none'
                }

                return (
                  <article key={i} className={ classnames('highlight') } style={{ 'display' : showVideo, 'minHeight' : '200px' }}>
                    <Video showCaption={true} { ...video } />
                  </article>
                )
              })
            }
            { enableLazyload &&
              <Lazyload page={page} threshold={0.3} hasMore={hasMore} updateMore={updateMoreVideos} enableForceLazyload={enableForceLazyload}/>
            }
            </div>
          }
        </div>
      </div>
    )
  }
}

export default VideoGrid



// WEBPACK FOOTER //
// ../app/components/gamepackage/VideoGrid.jsx